import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import logo from "../../images/meta-business-partner.png";

const Wrap = styled.section`
  padding: 5rem 0;
`;

const Inner = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 1.5rem;

  @media (min-width: 768px) { padding: 0 2rem; }
`;

const Banner = styled(motion.div)`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  align-items: center;
  background: var(--bg);
  border: 1px solid var(--rule);
  border-radius: 20px;
  padding: 1.6rem 1.75rem;

  @media (min-width: 760px) {
    grid-template-columns: 120px 1px 1fr auto;
    padding: 1.6rem 2.4rem;
    gap: 2rem;
  }
`;

const LogoWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100px;
    height: auto;
    display: block;
    object-fit: contain;
  }
`;

const Divider = styled.span`
  display: none;
  @media (min-width: 760px) {
    display: block;
    width: 1px;
    height: 56px;
    background: var(--rule);
  }
`;

const TextCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;

  @media (max-width: 759px) {
    text-align: center;
    align-items: center;
  }
`;

const Verified = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: var(--mono);
  font-size: 0.66rem;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--wa-green-d);
  font-weight: 500;

  svg { width: 11px; height: 11px; }
`;

const Statement = styled.h3`
  font-family: var(--sans);
  font-weight: 600;
  font-size: clamp(1.15rem, 2.2vw, 1.5rem);
  letter-spacing: -0.018em;
  margin: 0;
  color: var(--ink);
  line-height: 1.3;
`;

const Caption = styled.p`
  font-family: var(--sans);
  font-size: 0.9rem;
  color: var(--ink-2);
  margin: 0.3rem 0 0;
  max-width: 48ch;
  line-height: 1.5;
`;

const Since = styled.div`
  font-family: var(--sans);
  text-align: right;

  .y {
    font-weight: 600;
    font-size: 2rem;
    line-height: 1;
    letter-spacing: -0.02em;
    color: var(--accent);
  }
  .k {
    display: block;
    font-family: var(--mono);
    font-size: 10px;
    letter-spacing: 0.22em;
    color: var(--ink-3);
    margin-top: 6px;
    text-transform: uppercase;
  }

  @media (max-width: 759px) { text-align: center; }
`;

export default function MetaPartner() {
  return (
    <Wrap>
      <Inner>
        <Banner
          initial={{ opacity: 0, y: 22 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.65, ease: [0.16, 1, 0.3, 1] }}
        >
          <LogoWrap>
            <img src={logo} alt="Meta Business Partner" />
          </LogoWrap>
          <Divider />
          <TextCol>
            <Verified>
              <svg viewBox="0 0 12 12" fill="none" aria-hidden="true">
                <path d="M2 6.5l2.5 2.5L10 3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              Verified by Meta
            </Verified>
            <Statement>Meta Business Partner en WhatsApp API.</Statement>
            <Caption>
              Proveedor tecnológico verificado por Meta — operamos sobre la
              WhatsApp Business Platform oficial.
            </Caption>
          </TextCol>
          <Since>
            <span className="y">2023</span>
            <span className="k">desde</span>
          </Since>
        </Banner>
      </Inner>
    </Wrap>
  );
}
